import React from 'react'

const BellIcon: React.FC = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 9.3335C21 7.47698 20.2625 5.6965 18.9497 4.38375C17.637 3.07099 15.8565 2.3335 14 2.3335C12.1435 2.3335 10.363 3.07099 9.05025 4.38375C7.7375 5.6965 7 7.47698 7 9.3335C7 17.5002 3.5 19.8335 3.5 19.8335H24.5C24.5 19.8335 21 17.5002 21 9.3335Z"
        stroke="rgba(28, 28, 28, 0.3)"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0181 24.5C15.813 24.8536 15.5186 25.1471 15.1644 25.3511C14.8102 25.5551 14.4086 25.6625 13.9998 25.6625C13.591 25.6625 13.1894 25.5551 12.8352 25.3511C12.481 25.1471 12.1866 24.8536 11.9814 24.5"
        stroke="rgba(28, 28, 28, 0.3)"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default BellIcon
